package com.exura.components.dialogs.imageSelection

import com.exura.features.localization.commonLocalization
import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLImageElement
import org.w3c.files.File
import org.w3c.files.FilePropertyBag
import org.w3c.files.FileReader
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException

internal object ImageProcessor {
    private const val MAX_SIZE = 480
    private const val JPEG_QUALITY = 0.8
    private const val MAX_SIZE_BYTES = 1024 * 1024

    suspend fun processImage(file: File): File {
        if (file.type.contains("svg") || file.size.toDouble() <= MAX_SIZE_BYTES) return file

        return compressImage(file)
    }

    private suspend fun compressImage(file: File): File = suspendCancellableCoroutine { cont ->
        val filename = file.name
        val reader = FileReader()
        val img = document.createElement("img") as HTMLImageElement

        reader.onload = { e ->
            img.src = (e.target as FileReader).result as String
        }
        img.onload = {
            val canvas = document.createElement("canvas") as HTMLCanvasElement
            var width = img.width
            var height = img.height

            if (width > height) {
                if (width > MAX_SIZE) {
                    height = (height * (MAX_SIZE.toDouble() / width)).toInt()
                    width = MAX_SIZE
                }
            } else {
                if (height > MAX_SIZE) {
                    width = (width * (MAX_SIZE.toDouble() / height)).toInt()
                    height = MAX_SIZE
                }
            }
            canvas.width = width
            canvas.height = height

            val ctx = canvas.getContext("2d") as CanvasRenderingContext2D
            ctx.drawImage(img, 0.0, 0.0, width.toDouble(), height.toDouble())

            // Export to Blob -> File
            canvas.toBlob(
                _callback = { blob ->
                    if (blob != null) {
                        val newFile = File(arrayOf(blob), filename, FilePropertyBag(type = "image/jpeg"))
                        cont.resume(newFile)
                    } else {
                        cont.resumeWithException(Exception(commonLocalization.current.errors.unknownErrorOccurred))
                    }
                },
                type = "image/jpeg",
                quality = JPEG_QUALITY,
            )
        }
        reader.readAsDataURL(file)
    }
}
